// src/components/Common/ConfirmDialog.js
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button
} from "@mui/material";

const ConfirmDialog = ({
    open,
    title = "Confirmation required",
    content = "You are going to delete. Are you sure?",
    confirmText = "Yes",
    cancelText = "No",
    onConfirm,
    onClose
}) => {
    const handleCancel = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        if (onClose) {
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={handleCancel}>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {content}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} variant={"outlined"} color="primary">
                    {cancelText}
                </Button>
                <Button onClick={handleConfirm} variant={"contained"} color="warning" autoFocus>
                    {confirmText}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmDialog;
